export const socketEvents = {
  WORKSPACE_SUPPORT_IN: "workspace:support:in",
};
